// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_T1e","cls2":"ClaimEvaluationRow-cls2_MG1 ClaimEvaluationRow-cls1_T1e"};